var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 0C1.2 0 0 1.2 0 2.7C0 4.2 1.2 5.4 2.7 5.4C4.2 5.4 5.4 4.2 5.4 2.7C5.4 1.2 4.2 0 2.7 0ZM2.7 3.8C2.1 3.8 1.5 3.3 1.5 2.6C1.5 1.9 2 1.4 2.7 1.4C3.4 1.4 3.9 1.9 3.9 2.6C3.9 3.3 3.3 3.8 2.7 3.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 6.2002H0.8C0.3 6.2002 0 6.5002 0 6.9002C0 7.3002 0.3 7.7002 0.8 7.7002H3.9V18.5002H1.5V10.0002C1.5 9.6002 1.2 9.2002 0.7 9.2002C0.2 9.2002 0 9.6002 0 10.0002V19.2002C0 19.7002 0.3 20.0002 0.8 20.0002H4.6C5 20.0002 5.4 19.7002 5.4 19.2002V6.9002C5.4 6.5002 5 6.2002 4.6 6.2002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6996 7.4001C17.7996 6.5001 16.5996 6.1001 15.3996 6.1001H14.5996C13.4996 6.1001 12.4996 6.3001 11.4996 6.8001C11.4996 6.4001 11.0996 6.1001 10.6996 6.1001H6.89961C6.49961 6.1001 6.09961 6.4001 6.09961 6.9001V19.2001C6.09961 19.6001 6.39961 20.0001 6.89961 20.0001H10.6996C11.0996 20.0001 11.4996 19.7001 11.4996 19.2001V12.3001C11.4996 11.5001 12.1996 10.8001 12.9996 10.8001C13.7996 10.8001 14.4996 11.5001 14.4996 12.3001V19.2001C14.4996 19.6001 14.7996 20.0001 15.2996 20.0001H19.0996C19.4996 20.0001 19.8996 19.7001 19.8996 19.2001V10.7001C19.9996 9.5001 19.5996 8.3001 18.6996 7.4001ZM18.4996 18.5001H16.1996V12.3001C16.1996 10.6001 14.7996 9.2001 13.0996 9.2001C11.3996 9.2001 9.99961 10.6001 9.99961 12.3001V18.5001H7.69961V7.7001H9.99961V8.5001C9.99961 8.8001 10.1996 9.1001 10.4996 9.2001C10.7996 9.3001 11.0996 9.3001 11.2996 9.0001C11.9996 8.2001 12.5996 7.7001 14.5996 7.7001H15.3996C16.1996 7.7001 16.9996 8.0001 17.5996 8.5001C18.1996 9.1001 18.4996 9.9001 18.3996 10.7001V18.5001H18.4996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.06175831b534132f24b57829dd2131ee.svg";
export { ForwardRef as ReactComponent };